import React from 'react';
import { Link, BrowserRouter } from "react-router-dom";
import "./home_top.css";
import flim from "./Im/flim.png"
import admin from "./Im/admit.png"
import showcase from "./Im/showcase.png"
import re_part2_1 from "./Im/re_part2_1.png"
import rebg from "./Im/rebg.png"
import re_beg2 from "./Im/re_beg2.png"
import hpoints from "./Im/hundred-points.png"


export default function Home_top() {

    function handleResource(){
        document.querySelector(".resource-container").classList.add("resource-container-active");
    }
    function resourceClose(){
        document.querySelector(".resource-container").classList.remove("resource-container-active");
    }
    return <div className="home-full">
    
        <div className="home-text">
            <div className="home-set">
                <p className="home-heading">Own a piece <br></br>of history</p>
                <br></br>
                <p className="para">Ever had a chill run down your spine when you see "superstar Rajinikanth" in big bold words at the cinema? What if you could own that moment? If you're a fan of cinema this is the place for you.
                Diginoor lets you own a piece of your favourite movie and star,
                Shah Rukh Khan or Rajnikanth, a moment which you & only you will 
                uniquely own. Want your share of history?
                </p>
                <div className="home-bt">
                    <Link to ="/collections"><button className="bbn632-hover bn28" id="home-bbt">CLAIM NOW</button></Link>
                    <br></br>  <br></br>  <br></br>  <br></br>  <br></br>
                </div>
              
                <div className="raj_home">  
                
                </div>
            </div>
                </div>
                
                {/*<div>
                    <Spbdrop />
            </div>*/}

        <div className=" resource-container">
        <button onClick={()=>resourceClose()} className='resource-close'>X</button>
            <div className='resource-content'>
            
            <h2 className="re-heading">RESOURCES TO GET YOU STARTED <img src={hpoints} className="hpoints" /></h2>
            <div className="re-cards">
                <div className="re-card">
                <Link to="/collections"><div className="re">
                    <img className="re_immg" src={flim} alt="Logo" />
                    <Link to ="/collections"><h3 className="re_menu1">View collections</h3></Link>
                </div></Link>
               <Link to="/marketplace"> <div className="re">
                    <img className="re_immg" src={admin} alt="Logo" />
                    <h3 className="re_menu2"  id="re-market">Trade on the marketplace</h3>
                </div></Link>
               <Link to="/profile"> <div className="re">
                    <img className="re_immg" src={showcase} alt="Logo" />
                    <h3 className="re_menu3">Build your showcase</h3>
                </div></Link>
                </div>
            </div>

            <div className="re-part2">
               <Link to="/how it works"> <div className="re-everthing">
                    <img className="re_part2_1" src={re_part2_1} alt="Logo" />
                    <h1 className="re_part2_text1">Everything you need to know</h1>
                </div></Link>
               
                    <div className="re-beginers_guide">
                    <Link to={`/blog/${'what-is-an-nft'}`}>
                    <div className="re-beginers1">
                        <img className="re-img" src={re_beg2} alt="Logo" />
                        <div class="overlay">What is an NFT ?</div>
                    </div> 
                    </Link>
                    <Link to={`/blog/${'a-beginners-guide-to-diginoor'}`}>
                    <div className="re-beginers-2">
                        <img className="re-img" src={rebg} alt="Logo" />
                        <div class="overlay">Beginners guide to Diginoor</div>
                    </div>
                    </Link>
                </div>
            </div>
        </div>
        </div>
        <button text='Resources' onClick={()=>handleResource()} className="float"><img src={hpoints}/></button>
    </div>

}